import React from "react";
import { pdf } from "@react-pdf/renderer";
import filedownload from "js-file-download";

function useDownload() {
  const handleDownloadPDFRender = async (component: React.ReactElement, name: string) => {
    const blob = await pdf(component).toBlob();
    filedownload(blob, name);
  };

  return { handleDownloadPDFRender };
}

export default useDownload;
